import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { EmitterService } from '../../services/emitter.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-actions-snowman-menu',
  templateUrl: './actions-snowman-menu.component.html',
  styleUrls: ['./actions-snowman-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class ActionsSnowmanMenuComponent implements OnChanges {
  private emitterService = inject(EmitterService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() public menu: ISnowManMenu<any, any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() public action = new EventEmitter<any>();
  @Output() public opened = new EventEmitter<boolean>();
  @Input() public parentRequestMenuClose: boolean;
  @Input() public positionToContainer?: boolean = false;

  public isOpen: boolean;

  public ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (Object.prototype.hasOwnProperty.call(changes, propName)) {
        switch (propName) {
          case 'parentRequestMenuClose':
            if (changes.parentRequestMenuClose.currentValue) {
              this.closeMenu();
            }
            break;
        }
      }
    }
  }

  public openSnowmanMenu(): void {
    this.isOpen = true;
    this.opened.emit(true);
    this.emitterService.setFooterMargin(true);
  }

  public closeMenu(): void {
    this.isOpen = false;
    this.emitterService.setFooterMargin(false);
  }

  public onActionSelect(selection: string): void {
    this.action.emit(selection);
    this.closeMenu();
  }
}

export interface ISnowManMenu<OptionsT, OptionForT> {
  i: number;
  options: OptionsT[];
  data: OptionForT;
}

export interface ISnowManAction<ActionT, ItemT> {
  action: ActionT;
  item: ItemT;
  itemIndex?: number;
}
